import { SVG } from '../SVG'

const PinIcon = ({ style = {}, ...props }) => (
  <SVG width='12' height='14' viewBox='0 0 12 14' fill='none' xmlns='http://www.w3.org/2000/svg' style={{ ...style }} {...props}>
    <path
      opacity='0.25'
      d='M11.25 5.83398C11.25 9.03747 8.4352 11.7718 6.92773 13.0065C6.38118 13.4541 5.61882 13.4541 5.07227 13.0065C3.5648 11.7718 0.75 9.03747 0.75 5.83398C0.75 2.93449 3.1005 0.583984 6 0.583984C8.8995 0.583984 11.25 2.93449 11.25 5.83398Z'
      fill='var(--svg-darker-fill)'
    />
    <path
      d='M7.75 5.25C7.75 6.2165 6.9665 7 6 7C5.0335 7 4.25 6.2165 4.25 5.25C4.25 4.2835 5.0335 3.5 6 3.5C6.9665 3.5 7.75 4.2835 7.75 5.25Z'
      fill='var(--svg-darker-fill)'
    />
  </SVG>
)

export default PinIcon
